export default [
	{
		name: 'Health & Wellness',
		subject: 'health_wellness'
	},
	{
		name: 'Professional Development',
		subject: 'professional_development'
	},
	{
		name: 'Science',
		subject: 'science'
	},
	{
		name: 'Social Studies',
		subject: 'social_studies'
	},
	{
		name: 'Other',
		subject: 'other'
	},
]
